// src/hooks/useScrollSpy.js
import { useEffect, useState } from "react";

export default function useScrollSpy(sectionIds, offset = 0) {
  const [activeId, setActiveId] = useState(null);

  useEffect(() => {
    let ticking = false;

    const handleScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          const scrollY = window.scrollY + offset;
          let currentId = null;

          for (const id of sectionIds) {
            const el = document.getElementById(id);
            if (el) {
              const top = el.offsetTop;
              const bottom = top + el.offsetHeight;

              if (scrollY >= top && scrollY < bottom) {
                currentId = id;
                break;
              }
            }
          }

          setActiveId(currentId);
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();

    return () => window.removeEventListener("scroll", handleScroll);
  }, [sectionIds, offset]);

  return activeId;
}
